import {useMemo} from 'react';

import type {FilterObject} from 'nutshell-core/types';

import type {ReportURLParams} from '../../../reports/report-types';

import {GraduatedFilter} from '../../entity-lists/graduated-filter';
import type {Option} from '../../entity-lists/graduated-filter';

type Props = {
    filters: FilterObject[];
    urlParams: ReportURLParams<'mcfxcompanies'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
};

export function AddedStatusFilter(props: Props) {
    const defaultOption = useMemo(() => ({value: {all: null}, label: 'All visitors'}) as const, []);

    const options = useMemo(() => {
        return [
            defaultOption,
            {value: {added: '*'}, label: 'Added'},
            {
                value: {notAdded: '-'},
                label: 'Not added',
            },
        ];
    }, [defaultOption]);

    const unlockFilter = props.filters.find((filterObj) =>
        Object.prototype.hasOwnProperty.call(filterObj, 'convertedTime')
    );
    const activeFilter = unlockFilter
        ? options.find((opt) => Object.values(opt.value)[0] === unlockFilter.convertedTime)
        : undefined;
    const activeFilterKey = activeFilter ? Object.keys(activeFilter.value)[0] : 'all';

    return (
        <GraduatedFilter
            {...props}
            getNewFilters={(option: Option) => {
                // Remove any existing convertedTime filter
                const newFilters = props.filters.filter(
                    (filterObj) => !Object.prototype.hasOwnProperty.call(filterObj, 'convertedTime')
                );

                // If they are filtering by convertedTime, add the appropriate filter
                if (!option.value.all) {
                    return newFilters.concat({convertedTime: Object.values(option.value)[0]});
                } else {
                    return newFilters;
                }
            }}
            activeFilterKey={activeFilterKey}
            defaultOption={defaultOption}
            options={options}
        />
    );
}
